import {forwardRef, useState} from "react";

import {
    UsernameTextField,
    type CommonUsernameTextFieldProps,
} from "./username-text-field.tsx";

type UncontrolledProps = CommonUsernameTextFieldProps & {
    /**
     * The initial input value.
     */
    initialValue?: string;
};

export const UncontrolledUsernameTextField = forwardRef<
    HTMLInputElement,
    UncontrolledProps
>((props, ref) => {
    const [value, setValue] = useState(props.initialValue || "");

    const handleChange = (newValue: string) => {
        setValue(newValue);
        props.onChange(newValue);
    };

    return (
        <UsernameTextField
            {...props}
            value={value}
            onChange={handleChange}
            ref={ref}
        />
    );
});
